// Header Search Dropdown Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Elements
  const searchForms = document.querySelectorAll('.header-search-new form');
  
  if (!searchForms.length) return;
  
  // Add event listeners to each search form
  searchForms.forEach(form => {
    const searchInput = form.querySelector('.search-input');
    
    if (!searchInput) return;
    
    // Create results container if it doesn't exist
    let resultsContainer = form.parentNode.querySelector('.search-results');
    if (!resultsContainer) {
      resultsContainer = document.createElement('div');
      resultsContainer.className = 'search-results';
      resultsContainer.style.display = 'none';
      form.parentNode.appendChild(resultsContainer);
    }
    
    // Handle input events
    searchInput.addEventListener('input', debounce(function(e) {
      const query = e.target.value.trim();
      
      if (query.length < 2) {
        resultsContainer.style.display = 'none';
        return;
      }
      
      // Fetch search results
      fetchSearchResults(query, resultsContainer);
    }, 300));
    
    // Hide results when clicking outside
    document.addEventListener('click', function(e) {
      if (!form.contains(e.target) && !resultsContainer.contains(e.target)) {
        resultsContainer.style.display = 'none';
      }
    });
    
    // Prevent form submission when pressing Enter in the search field
    // Instead, navigate to the first result or submit the form if no results
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && resultsContainer.style.display !== 'none') {
        const firstResult = resultsContainer.querySelector('.search-result-item');
        if (firstResult) {
          e.preventDefault();
          window.location.href = firstResult.href;
        }
      }
    });
  });
  
  // Fetch search results from Shopify
  function fetchSearchResults(query, resultsContainer) {
    const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title,vendor,tag`;
    
    fetch(url)
      .then(response => response.json())
      .then(data => {
        const products = data.resources.results.products || [];
        
        if (products.length === 0) {
          resultsContainer.style.display = 'none';
          return;
        }
        
        // Build results HTML
        let resultsHTML = '<div class="search-results-inner">';
        
        products.forEach(product => {
          const image = product.image || 'product-1.svg';
          const price = product.price_min ? formatMoney(product.price_min) : '';
          const comparePrice = product.compare_at_price_min && product.compare_at_price_min > product.price_min 
            ? formatMoney(product.compare_at_price_min) 
            : '';
          
          resultsHTML += `
            <a href="${product.url}" class="search-result-item">
              <div class="search-result-image-container">
                <img src="${image}" alt="${product.title}" class="search-result-image">
              </div>
              <div class="search-result-content">
                <div class="search-result-title">${product.title}</div>
                <div class="search-result-price">
                  ${comparePrice ? `<span class="price-item price-item--regular">${comparePrice}</span>` : ''}
                  <span class="price-item ${comparePrice ? 'price-item--sale' : ''}">${price}</span>
                </div>
              </div>
            </a>
          `;
        });
        
        if (products.length > 0) {
          resultsHTML += `
            <div class="search-results-footer">
              <a href="/search?q=${encodeURIComponent(query)}&type=product" class="search-results-view-all">
                View all results
              </a>
            </div>
          `;
        }
        
        resultsHTML += '</div>';
        
        // Update and show results
        resultsContainer.innerHTML = resultsHTML;
        resultsContainer.style.display = 'block';
      })
      .catch(error => {
        console.error('Error fetching search results:', error);
        resultsContainer.style.display = 'none';
      });
  }
  
  // Helper function to format money
  function formatMoney(cents) {
    const format = '${{amount}}';
    
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || '${{amount}}';
    
    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }
    
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      
      if (isNaN(number) || number == null) {
        return 0;
      }
      
      number = (number / 100.0).toFixed(precision);
      
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsAmount = parts[1] ? (decimal + parts[1]) : '';
      
      return dollarsAmount + centsAmount;
    }
    
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }
    
    return formatString.replace(placeholderRegex, value);
  }
  
  // Debounce function to limit API calls
  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    };
  }
});
